import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/KitchenRenovation.jpg";
import {MdKitchen} from "react-icons/md";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function KitchenRemodelingPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Kitchen Remodeling Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Explore premier kitchen remodeling services in Charlotte NC. Our expert team delivers quality solutions for your renovation needs. Contact for a consultation!"
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><MdKitchen className={classes.servicesIcon}/> {languageContext.services.KitchenRemodelingPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.KitchenRemodelingPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.KitchenRemodelingPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.KitchenRemodelingPage.text2}</span>
                            <br/>
                            {languageContext.services.KitchenRemodelingPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.KitchenRemodelingPage.text4}</span>
                            <br/>
                            {languageContext.services.KitchenRemodelingPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.KitchenRemodelingPage.text6}</span>
                            <br/>
                            {languageContext.services.KitchenRemodelingPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.KitchenRemodelingPage.text8}</span>
                            <br/>
                            {languageContext.services.KitchenRemodelingPage.text9}
                            <br/><br/>
                            <span>{languageContext.services.KitchenRemodelingPage.text10}</span>
                            <br/>
                            {languageContext.services.KitchenRemodelingPage.text11}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.imageHorizontal}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default KitchenRemodelingPage;